import React from 'react';
import { Box, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

export const RECOMMENDED_LABEL = 'Top pick';

export const RecommendedStar: React.FC = () => (
  <Tooltip title={RECOMMENDED_LABEL} placement="top">
    <Box
      component="span"
      role="img"
      aria-label={RECOMMENDED_LABEL}
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        padding: '0.125rem',
        borderRadius: '0.25rem',
        color: 'text.brand',
      }}
    >
      <StarIcon sx={{ fontSize: '1rem' }} />
    </Box>
  </Tooltip>
);
